import React, { useContext, useEffect, useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { UserContext } from '../../../context/authContext';
import { useAlert } from '../../../context/alertContext';
import axios from 'axios';
import { AsYouType } from 'libphonenumber-js';
import { decode } from 'jsonwebtoken';
import { Loader2, X } from 'lucide-react';
import CheckoutPage from './checkoutPageSub';
import SelectOptionsPage from './selectedOptionsPage';
import { Address } from '../../../lib/models/interfaces';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { TandCModal } from '../tnc_modal/tncModal';
import { buttonStyle } from '../style/styleSet';

interface NewAccountInfo {
  companyName: string;
  primaryAdmin: string;
  adminEmail: string;
  customerId: string;
  contactNumber: string;
  stripeCustomerId: string;
}
enum AddressNames {
  street = 'street',
  city = 'city',
  state = 'state',
  zip = 'zip',
  country = 'country'
}

const getUserInfo = (token: string) => {
  const decodedToken = decode(token) as unknown as any;
  console.log('decoded token', decodedToken);
  return decodedToken;
};
/**
 * CreateAccountNew
 * ---------------
 * - Company Name, Primary Contact, Telephone Number, Full Address
 * - Styled to match LoginPageNew.tsx
 * - No state/logic, just layout and styling
 */
const CreateAccountNew: React.FC = () => {
  const {
    auth,
    token,
    companyAccount,
    updateTNC,
    setShowNoticeModal,
    privacyAccepted,
    countryAccepted
  } = useContext(UserContext);
  const { setAlert } = useAlert();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  /// state
  const [address, setAddress] = useState<Address>({
    street: '',
    city: '',
    state: '',
    zip: '',
    country: ''
  });
  const [companyName, setCompanyName] = useState<string>('');
  const [primaryContact, setPrimaryContact] = useState<string>('');
  const [tel, setTel] = useState<string>('');
  const [notes, setNotes] = useState<string>('');
  const [primaryEmail, setPrimaryEmail] = useState<string>('');
  const [accountManager, setAccountManager] = useState<string>('');

  const [emailError, setEmailError] = useState<string>('');

  const [createAccountLoading, setCreateAccountLoading] =
    useState<boolean>(false);
  const [newAccountInfo, setNewAccountInfo] = useState<any | null>(null);
  const [showPayment, setShowPayment] = useState<boolean>(false);
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<string | null>(null);
  const [ackTNC, setAckTMC] = useState<boolean>(false);

  const [showExpiredMessage, setShowExpiredMessage] = useState<string | null>(
    null
  );

  // use effects
  useEffect(() => {
    console.log(
      'is greater than now',
      companyAccount?.subscriptions?.at(-1)?.current_period_end! > Date.now()
    );
    console.log('company account', companyAccount);
    if (
      companyAccount?.stripeCustomerId &&
      companyAccount.subscriptions &&
      companyAccount.subscriptions.length === 0
    ) {
      loadAccountInfo();
      console.log('account created but no subscription.', companyAccount);
      setShowOptions(true);
      setShowPayment(false);
    }
    if (
      companyAccount?.stripeCustomerId &&
      companyAccount?.subscriptions &&
      companyAccount.subscriptions.length > 0 &&
      companyAccount?.subscriptions?.at(-1)?.current_period_end! > Date.now()
    ) {
      console.log('navigating to landing');
      navigate('/app/landing');
    }
  }, []);

  const loadAccountInfo = () => {
    if (!companyAccount) return;
    setCompanyName(companyAccount?.companyName);
    setPrimaryContact(companyAccount?.primaryAdmin);
    setPrimaryEmail(companyAccount?.primaryEmail);
    setTel(companyAccount?.contactNumber);
    setAddress(companyAccount?.address);
    setNewAccountInfo(companyAccount);
  };

  // functions

  const handleChange = (detail: string, name: AddressNames) => {
    console.log('handle change', detail, name);
    const temp = address;
    temp[name] = detail;
    console.log('combo', temp[name]);
    // const str = JSON.stringify(temp);
    // const parse = JSON.parse(str);
    setAddress({ ...temp });
  };

  const createAccount = async () => {
    if (!token) return;
    try {
      console.log('token account', token);
      setCreateAccountLoading(true);
      const user = getUserInfo(token);
      console.log('user', user);
      if (user.email && user.email_verified) {
        setPrimaryEmail(user.email);
      }
      if (!user.email && !user.email_verified) {
        setEmailError('Missing Email or Email not verified');
      }
      console.log('sub', user.sub, 'username', user.username);
      const account = {
        companyName: companyName,
        address: address,
        contactNumber: tel,
        primaryAdmin: primaryContact,
        primaryEmail: user.email
      };
      if (
        !account.address ||
        !account.companyName ||
        !account.contactNumber ||
        !account.primaryAdmin ||
        !account.primaryEmail
      ) {
        alert('Missing Info');
        return;
      }
      const result = await axios.post(
        `${process.env.REACT_APP_KORU_API}/account?type=createNewCustomerSS`,
        {
          account
        },
        auth
      );
      // setAlert(
      //   `Created New Customer with account no - ${result.data.result.customerId}`,
      //   'success',
      //   3
      // );
      console.log('new customer created', JSON.stringify(result.data));
      const accountNew = result.data.result.account;
      // const tempAccountInfo: NewAccountInfo = {
      //   companyName: accountNew.companyName,
      //   primaryAdmin: accountNew.primaryAdmin,
      //   adminEmail: accountNew.primaryEmail,
      //   customerId: accountNew.customerId,
      //   contactNumber: accountNew.contactNumber,
      //   stripeCustomerId: accountNew.stripeCustomerId
      // };
      // update TNC for primary user
      try {
        await updateTNC();
      } catch (e) {
        //no op//
      }
      setNewAccountInfo(accountNew);
      setShowOptions(true);
      setShowPayment(false);
      setCreateAccountLoading(false);
    } catch (e) {
      const error = e as Error;
      setCreateAccountLoading(false);
      setAlert(`Oops something went wrong. Please try again`, 'error');
    }
  };

  const handleReset = () => {
    setAddress({
      street: '',
      city: '',
      state: '',
      zip: '',
      country: ''
    });
    setAccountManager('');
    setCompanyName('');
    setTel('');
    setPrimaryContact('');
    setPrimaryEmail('');
    setNotes('');
    setEmailError('');
  };
  const disableButton = useMemo(() => {
    const regex = /^\(\d{3}\) \d{3}-\d{4}$/;
    const isTelValid = regex.test(tel);
    if (
      companyName === '' ||
      !isTelValid ||
      primaryContact === '' ||
      address.street === '' ||
      address.city === '' ||
      address.state === '' ||
      address.country === '' ||
      address.zip === '' ||
      !privacyAccepted ||
      !countryAccepted
    ) {
      return true;
    } else {
      return false;
    }
  }, [companyName, tel, primaryContact, address]);

  useEffect(() => {
    const pickNewSubscription = searchParams.get('nosub') === 'true';
    const expiredSub = searchParams.get('expiredSub') === 'true';
    if (expiredSub) {
      setShowExpiredMessage(
        'Your subscription has expired or was cancelled, pick a subscription to continue.'
      );
    }
    if (companyAccount?.subscriptions?.at(-1)?.status === 'canceled') {
      setShowExpiredMessage(
        'The subscription was cancelled. Please select a new subscription.'
      );
    }
    if (pickNewSubscription) {
      loadAccountInfo();
      setShowOptions(true);
    }
  }, []);
  useEffect(() => {
    if (!companyAccount) {
      return;
    } else {
      setNewAccountInfo(companyAccount);
    }
  }, [companyAccount]);

  return (
    <div
      className="fixed inset-0 overscroll-none overflow-hidden w-full bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-[#62d29e]/40 via-[#62d29e]/20 to-white dark:from-slate-950 dark:via-slate-950 dark:to-black flex items-center justify-center p-6"
      id="account-new"
    >
      <div className="pointer-events-none fixed inset-0 opacity-[0.04] [background-image:linear-gradient(to_right,theme(colors.slate.500/.35)_1px,transparent_1px),linear-gradient(to_bottom,theme(colors.slate.500/.35)_1px,transparent_1px)] [background-size:32px_32px]" />
      {!showPayment && !showOptions ? (
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className="relative z-10 w-full max-w-3xl"
        >
          <div className="rounded-2xl border border-black/5 dark:border-white/10 bg-white/80 dark:bg-slate-900/50 backdrop-blur-xl shadow-[0_20px_60px_-20px_rgba(0,0,0,0.4)]">
            {/* Header */}
            <div className="px-8 pt-8 pb-4 text-center">
              <img
                src="/korulogo.png"
                alt="Koru Logo"
                className="mx-auto mb-4 h-12 w-12 object-contain"
                loading="eager"
                decoding="async"
              />
              <h1 className="text-2xl font-semibold text-slate-900 dark:text-white">
                Complete Account Setup
              </h1>
            </div>
            {/* Form */}
            <form
              className=" px-8 pb-8 pt-4 space-y-5"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                {/* LEFT: Company / Contact / Tel */}
                <div className="space-y-5">
                  <div>
                    <label
                      htmlFor="companyName"
                      className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-200"
                    >
                      Company Name
                    </label>
                    <input
                      id="companyName"
                      name="companyName"
                      type="text"
                      placeholder="Your Company Inc."
                      onChange={(e) => setCompanyName(e.target.value)}
                      value={companyName}
                      className="block w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-white/60 dark:bg-slate-800/60 px-3 py-2.5 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-slate-900 transition"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="primaryContact"
                      className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-200"
                    >
                      Primary Contact
                    </label>
                    <input
                      id="primaryContact"
                      name="primaryContact"
                      type="text"
                      placeholder="Jane Doe"
                      value={primaryContact}
                      onChange={(e) => setPrimaryContact(e.target.value)}
                      className="block w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-white/60 dark:bg-slate-800/60 px-3 py-2.5 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-slate-900 transition"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="telephone"
                      className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-200"
                    >
                      Telephone Number
                    </label>
                    <input
                      id="telephone"
                      name="telephone"
                      type="text"
                      placeholder="(555) 867 5309"
                      value={tel}
                      onChange={(e) => {
                        if (e.target.value.length <= 5) {
                          setTel(e.target.value);
                        } else {
                          const newNumber = new AsYouType('US').input(
                            e.target.value
                          );
                          setTel(newNumber);
                        }
                      }}
                      className="block w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-white/60 dark:bg-slate-800/60 px-3 py-2.5 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-slate-900 transition"
                      autoComplete="tel"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="telephone"
                      className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-200"
                    >
                      {(!privacyAccepted || !countryAccepted) && (
                        <p>Terms and Conditions Need to be accepted</p>
                      )}
                    </label>
                    <button
                      className={buttonStyle}
                      onClick={() => setShowNoticeModal(true)}
                    >
                      View Terms
                    </button>
                  </div>
                </div>
                {/* RIGHT: Address */}
                <div className="space-y-5">
                  <div>
                    <label
                      htmlFor="street"
                      className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-200"
                    >
                      Street
                    </label>
                    <input
                      id="street"
                      name="street"
                      type="text"
                      placeholder="123 Main St"
                      value={address?.street}
                      onChange={(e) =>
                        handleChange(e.target.value, AddressNames.street)
                      }
                      className="block w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-white/60 dark:bg-slate-800/60 px-3 py-2.5 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-slate-900 transition"
                      autoComplete="street-address"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="city"
                      className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-200"
                    >
                      City
                    </label>
                    <input
                      id="city"
                      name="city"
                      type="text"
                      placeholder="Seattle"
                      value={address?.city}
                      onChange={(e) =>
                        handleChange(e.target.value, AddressNames.city)
                      }
                      className="block w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-white/60 dark:bg-slate-800/60 px-3 py-2.5 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-slate-900 transition"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="state"
                      className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-200"
                    >
                      State
                    </label>
                    <input
                      id="state"
                      name="state"
                      type="text"
                      placeholder="Washington"
                      value={address?.state}
                      onChange={(e) =>
                        handleChange(e.target.value, AddressNames.state)
                      }
                      className="block w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-white/60 dark:bg-slate-800/60 px-3 py-2.5 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-slate-900 transition"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="state"
                      className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-200"
                    >
                      Zip
                    </label>
                    <input
                      id="zip"
                      name="zip"
                      type="text"
                      placeholder="98100"
                      value={address?.zip}
                      onChange={(e) =>
                        handleChange(e.target.value, AddressNames.zip)
                      }
                      className="block w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-white/60 dark:bg-slate-800/60 px-3 py-2.5 text-slate-900 dark:text-slate-100 placeholder:text-slate-400 outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-slate-900 transition"
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="country"
                      className="mb-2 block text-sm font-medium text-slate-700 dark:text-slate-200"
                    >
                      Country
                    </label>

                    <select
                      id="country"
                      name="country"
                      className="block w-full rounded-xl border border-slate-200 dark:border-slate-700 bg-white/60 dark:bg-slate-800/60 px-3 py-2.5 text-slate-900 dark:text-slate-100 outline-none focus-visible:ring-2 focus-visible:ring-sky-500 focus-visible:ring-offset-2 focus-visible:ring-offset-white dark:focus-visible:ring-offset-slate-900 transition"
                      onChange={(e) =>
                        handleChange(e.target.value, AddressNames.country)
                      }
                      value={address?.country}
                    >
                      <option value="">Select Country</option>
                      <option value="USA">USA</option>
                    </select>
                  </div>
                </div>
              </div>
              {emailError && (
                <p
                  className="text-sm text-red-600 dark:text-red-400"
                  role="alert"
                >
                  {emailError}
                </p>
              )}
              {/* No submit button or logic */}
              <button
                className={buttonStyle}
                onClick={() => createAccount()}
                disabled={disableButton}
              >
                {createAccountLoading ? (
                  <>
                    <Loader2 className="h-4 w-4 animate-spin" />
                    Updating Information
                  </>
                ) : (
                  <>Update Account Information</>
                )}
              </button>
            </form>
          </div>
        </motion.div>
      ) : null}
      {showPayment && !showOptions ? (
        <div className="relative w-full max-w-[75vw] mx-auto  p-8 bg-[#58d9c5] rounded-xl ">
          <div className="absolute top-2 right-2">
            <X
              onClick={() => {
                setShowPayment(false);
                setShowOptions(true);
              }}
            />
          </div>
          <CheckoutPage
            stripeCustomerId={newAccountInfo?.stripeCustomerId}
            selectedOption={selectedOption}
            customerId={newAccountInfo?.customerId}
            setShowOptions={setShowOptions}
            setShowPayment={setShowPayment}
          />
        </div>
      ) : null}
      {showOptions && !showPayment ? (
        <SelectOptionsPage
          setSelectedOption={setSelectedOption}
          setShowOptions={setShowOptions}
          setShowPayment={setShowPayment}
          showExpiredMessage={showExpiredMessage}
        />
      ) : null}
      <TandCModal />
    </div>
  );
};

export default CreateAccountNew;
